module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/link_icon/link_media-f0983bc1c0aaea9f4f3c040bda0b4b74.svg&quot;;"